<template>
  <transition name="slide-fade">
    <div class='d-flex px-2'>
      <div class='w-100'>
        <div class="card border border-white">
          <div class='card-header text-white d-flex justify-content-between'>

            <div class='d-flex align-items-center'>
              <strong class="float-left mr-2">{{$ml.get('GROUP')}}</strong>
              <select class='new-input float-left' v-model='type'>
                <option selected> {{$ml.get('AND')}}  </option>
                <option> {{$ml.get('OR')}} </option>
              </select>
            </div>

            <div class='align-self-center'>
              <button type="button" class="btn btn-secondary" @click='addSubElem("EXPR")'> <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('EXPRESSION')}}</button>
              <button type="button" class="btn btn-secondary-t" @click='addSubElem("GROUP")'> <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('GROUP')}}</button>
              <button type="button" class="btn-remove" @click='removeThis' v-if='name'> <i>&#10005;</i></button>
              <!-- {{ queryString }} -->
            </div>          

          </div>
          <div v-if='subElem.length>0' class='card-body bg-light-primary d-flex flex-column'  >
            <draggable v-model='subElem'>
              
              <div class='subElemContainer border-bottom border-white px-2' v-for='elem in subElem' v-bind:key='elem.name'>    
                
                <expression-builder  v-if='elem.type=="EXPR"' :item='item' :selectedObject="elem.selObj" :name='elem.name' @kill='remove' @change='updateQuery' @sendQuery='sendQuery'></expression-builder>
                <group-builder v-if='elem.type=="GROUP"' :item='item' :selectedSavedSearch="elem.selObj" :name='elem.name' @kill='remove' @change='updateQuery' @sendQuery='sendQuery'></group-builder>
              </div>
            </draggable>
          </div>
        </div>

        <div v-if='!name'>
          <div class="float-left ">
            <button class="btn btn-info m-2" data-toggle="dropdown">{{(selectedSavedSearch.hasOwnProperty('_id'))?$ml.get('EDIT_SEARCH'):$ml.get('SAVE_SEARCH')}}</button>
            <div class="dropdown-menu p-2">
                <div class="form-group">
                  <label for="savedSearchName">{{$ml.get('ENTER_SAVED_SEARCH_NAME')}}</label>
                  <input v-model="savedSearchName" @input="setSearchName()" class="form-control" type="text" id="savedSearchName">
                </div>
                <button v-if="selectedSavedSearch.hasOwnProperty('_id')" class="btn btn-success" @click="editSearchF(selectedSavedSearch._id.$oid)">{{$ml.get('EDIT_SEARCH')}}</button>
                <button class="btn btn-success" @click="saveQuery">{{(selectedSavedSearch.hasOwnProperty('_id'))?$ml.get('SAVE_AS_NEW_SEARCH'):$ml.get('SAVE_SEARCH')}}</button>
            </div>
            <button v-if="selectedSavedSearch.hasOwnProperty('_id')" class="btn btn-delete m-2" @click="deleteSearchF(selectedSavedSearch._id.$oid)">{{$ml.get('DELETE')}}</button>
          </div>
          
          <button class='btn btn-success float-right m-2' @click='sendQuery'>{{$ml.get('SEARCH')}}</button>
        </div>

      </div>
      <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
  </transition>
</template>

<script>
  import expressionBuilder from './expression-builder.vue'
  import draggable from 'vuedraggable'
  import swal from 'sweetalert'

  import {mapActions} from 'vuex'
  
  export default {
    name: 'group-builder',
    components: {
      expressionBuilder,
      draggable
    },
    props: ['item', 'name','selectedSavedSearch'],
    data () {
      return {
        subElem: [],
        type: this.$ml.get('AND'),
        subType: '',
        savedSearchName:'',
        selectedObject:{
          key:'',
          val:''
        },
        itemForGroup:this.item
      }
    },
    watch: {
      type: function () {
        this.$emit('change', this.name, this.queryString)
      },

      item: function (newItem,OldItem) {
        // console.log('item changed in group*builder')
        if(OldItem!==undefined){
          this.subElem = []
        }
        if(!$.isEmptyObject(newItem) && this.selectedSavedSearch && this.selectedSavedSearch.searchData && this.subElem.length === 0){
          this.savedSearchName = this.selectedSavedSearch.savedSearchName || ''
          var sss = typeof this.selectedSavedSearch.searchData === 'object' ? this.selectedSavedSearch.searchData : JSON.parse(this.selectedSavedSearch.searchData)
          this.searchInputLoop(sss.searchInput)
        }
      },
      selectedSavedSearch:function(selectedSavedSearch){
        console.log("selectedSavedSearch in group builder")
        
        this.subElem = []
        this.savedSearchName = ''
        if(this.selectedSavedSearch && this.selectedSavedSearch.searchData){
          this.savedSearchName = this.selectedSavedSearch.savedSearchName || ''
          if(!$.isEmptyObject(this.item)){
            var sss = typeof this.selectedSavedSearch.searchData === 'object' ? this.selectedSavedSearch.searchData : JSON.parse(this.selectedSavedSearch.searchData)
            this.searchInputLoop(sss.searchInput)
          }
        }
        console.log(selectedSavedSearch)
      }
    },
    methods: {
      ...mapActions(['deleteSearch','getSavedSearches']),
      addSubElem: function (elemType,savedQuery,selObj) {
        console.log("this.itemForGroup addSubElem")
        console.log(this.itemForGroup)
        console.log("selObj")
        console.log(selObj)
        if($.isEmptyObject(this.item)){
            swal({
                title: this.$ml.get("WARNING"),
                text: this.$ml.get("PLEASE_SELECT_CATEGORY"),
                icon: "warning",
                dangerMode: true,
            })
          this.subElem = []
          this.savedSearchName = ''
          this.$emit('resetSavedSearch')
          return false
        }
        var sQuery=''
        var rName = this.randomName()
        if(savedQuery){
          sQuery=savedQuery
        }
        
        var subElemx = {
          type: elemType,
          name: rName,
          query: sQuery,
          selObj:''
        }
        
        if(selObj){
          subElemx['selObj'] = selObj
        }
        
        this.subElem.push(subElemx)
        
        if(savedQuery){
          this.updateQuery(rName,savedQuery)
        }
      },

      updateQuery: function (name, string) {
        //console.log('update: ' + string)
        for (var i = 0; i < this.subElem.length; i++) {
          if (this.subElem[i].name === name) {
            this.subElem[i].query = string
            this.$emit('change', this.name, this.queryString)
            break
          }
        }
      },

      remove: function (name) {
        //console.log('Request kill for ' + name)
        for (var i = 0; i < this.subElem.length; i++) {
          if (this.subElem[i].name === name) {
            this.subElem.splice(i, 1)
            break
          }
        }
      },

      removeThis: function () {
        this.$emit('kill', this.name)
      },

      sendQuery: function () {
        this.$emit('sendQuery', this.queryString)
      },

      saveQuery:function(){
        this.$emit('saveQuery', this.queryString , this.savedSearchName)
      },

      randomName: function () {
        var hash = Math.random().toString(36).substr(2)
        return hash
      },
      getGroupInfo(item){
        var group = {}
        group['type'] = Object.keys(item)[0]
        if(group.type=='$or'){
          group['label'] = this.$ml.get('OR')
        }else if(group.type=='$and'){
          group['label'] = this.$ml.get('AND')
        }
        return group
      },
      searchInputLoop(searchInput){
        if(searchInput){
          if(typeof searchInput === 'string'){
            searchInput = JSON.parse(searchInput)
          }
          var group = this.getGroupInfo(searchInput)
          // console.log("group")
          // console.log(group)
          //set initial group type
          this.type = group.label
          var query =''
          for(var i in searchInput[group.type]){
            var item = searchInput[group.type][i]
            // console.log("saved item")
            // console.log(item)
            // console.log("Object.keys(item)[0]")
            // console.log(Object.keys(item)[0])
            if(Object.keys(item)[0]=='$and'||Object.keys(item)[0]=='$or'){
              // console.log("item")
              // console.log(item)
              // console.log("typeof(item)")
              // console.log(typeof(item))
              var selObj = {}
              var searchData = {}
              searchData['searchInput'] = JSON.stringify(item)
              selObj['searchData'] = JSON.stringify(searchData)
              this.addSubElem("GROUP",'"'+Object.keys(item)[0]+'":"'+JSON.stringify(item[Object.keys(item)[0]])+'"',selObj)
            }else{
              var selObj = {}
              selObj['key']=Object.keys(item)[0]
              selObj['val']=item[Object.keys(item)[0]]
              console.log("selObj else iiçi")
              console.log(selObj)
              this.addSubElem('EXPR','"'+Object.keys(item)[0]+'":"'+item[Object.keys(item)[0]]+'"',selObj)
            }
          }
        }
      },
      deleteSearchF(savedSearchId){
        // console.log('savedSearchId : '+ savedSearchId)
        swal({
          title: this.$ml.get('WARNING'),
          text: this.$ml.get('DELETE_SEARCH_WARN'),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            
            var form={}
            form['savedSearchId'] = savedSearchId
            this.deleteSearch(form).then((res) => {

                if(res.data.status.code){

                  this.getSavedSearches()
                  this.$emit('searchDeleted')
                  this.$notify({ 
                      group: 'foo',
                      type: 'success', 
                      title: this.$ml.get('SUCCESSFUL'),
                      text: res.data.status.desc
                  })
                  
                }
            }).catch(e => {
                console.log(e)
            })
          }
        });
        
      },
      editSearchF(savedSearchId){
        // console.log('edit search')
        swal({
          title: this.$ml.get('WARNING'),
          text: this.$ml.get('EDIT_SEARCH_WARN'),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willEdit) => {
          if (willEdit) {
            this.$emit('editQuery', this.queryString , this.savedSearchName, savedSearchId) 
          }
        });
        
      },
      setSearchName(){
        this.selectedSavedSearch.savedSearchName = this.savedSearchName
      }
    },
    mounted(){
      // console.log("this.selectedSavedSearch.searchData in group builder mounted")
      // console.log(this.selectedSavedSearch)
      if(this.selectedSavedSearch && this.selectedSavedSearch.searchData && !$.isEmptyObject(this.item)){
        this.savedSearchName = this.selectedSavedSearch.savedSearchName || ''
        var sss = typeof this.selectedSavedSearch.searchData === 'object' ? this.selectedSavedSearch.searchData : JSON.parse(this.selectedSavedSearch.searchData)
        this.searchInputLoop(sss.searchInput)
      }
        
    },
    created(){
      this.$root.$refs.groupBuilder=this  
    },
    computed: {
      queryString: function () {
        var string = '"$and":['

        if (this.type === 'OR' || this.type === 'VEYA') {
          string = '"$or":['
        }
        var size = this.subElem.length
        for (var i = 0; i < size; i++) {
          string += '{' + this.subElem[i].query + '}'
          if (i < size - 1) {
            string += ','
          }
        }

        string += ']'

        if (!this.name) {
          string = '{' + string + '}'
        }

        return string
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wpx-100{
    width: 100px;
  }
  .card {
    width:100%;
    margin-bottom: 5px;
  }

  .card-header {
    padding: 2px;
    padding-left: 8px;
    padding-right: 5px;
    background-color: #3767a0;
    font-size: 18px;
    height: 40px;
  }

  .card-footer {
    padding: 5px;
    font-size: 12px;
  }

  .card-body {
    padding: 0;
    padding-top: 5px;
    background-color: #e6e7e8;
  }

  .btn-secondary {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 16px;
    background-color: #3c89d8;
  }
  .btn-secondary-t {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 16px;
    background-color:transparent;
    color:white;
  }

  .bg-light-primary{
      background-color: #E8F4FD;
  }
  .blank-div {
    width: 24px;
  }

  .btn-delete {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }
  .btn-danger {
    padding-top: 0;
    padding-left: 1px;
    padding-right: 1px;
    padding-bottom: 2px;
  }

  .btn-remove{
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
  .btn-remove i{
    border-radius: 4px;
    padding: 0px 3px;
    font-weight: 400;
    font-style: normal;
    background-color: #f44336;
    color: #FFF;
  }

  .btn-success {
    padding-left: 20px;
    padding-right: 20px;
  }

  img {
    width: 18px;
    height: 18px;
  }

  select {
    padding: 4px;
    font-size: 15px;
    height: 30px;
  }

  .slide-fade-enter-active {
    transition: all .15s ease;
  }

  .slide-fade-enter {
    transform: translateY(10px);
    opacity: 0;
  }

  @media screen and (min-width: 1366px) {
    .btn-secondary {
      font-size: 21px;
    }
    select{
      height:42px;
    }
    .card-header{
      font-size: 21px;
      height: 50px;
    }
  }
  @media (max-width:410px){
    .btn-secondary, .btn-secondary-t, .card-header {
      font-size: 13px;
      padding-right: 3px;
    }
    select{
      height:24px;
      font-size: 12px;
    }
  }
</style>
